<template>
    <div style="background: white;border-radius: 10px;border: 1px solid #cccccc;padding-bottom: 20px">
        <div class="profileTitle">
            <div class="chartTitle">
                <h3>Holland Profile</h3>
                <div class="profileCon">
                    Your results are: <br>
                    Realistic:<span>{{ holland[0] }}</span>,
                    Investigative:<span>{{ holland[1] }}</span>,
                    Artistic:<span>{{ holland[2] }}</span>,
                    Social:<span>{{ holland[3] }}</span>,
                    Enterprising:<span>{{ holland[4] }}</span>,
                    Conventional:<span>{{ holland[5] }}</span>,
                </div>
                <p>Research shows that personalities seek out and flourish in career environments they fit and that jobs and career
                    environments are classifiable by the personalities that flourish in them.</p>
            </div>
            <GChart
                    class="GoogleChart"
                    type="PieChart"
                    :data="chartData"
                    :options="chartOptions"
            />
        </div>
        <div class="profiletable">
            <div class="prorow">
                <div class="pro_l" style="border-top-left-radius: 8px">Personality Type</div>
                <div class="pro_r ground" style="border-top-right-radius: 8px">Description</div>
            </div>
            <div class="prorow">
                <div class="pro_l">Doers (Realistic)</div>
                <div class="pro_r">Independent, stable, persistent, genuine, practical, and thrifty [...] tasks that are tactile, physical, athletic, or
                mechanical [...] being outdoors, using tools, operating machines, interacting with animals, and working with their hands.</div>
            </div>
            <div class="prorow">
                <div class="pro_l">Thinkers (Investigative)</div>
                <div class="pro_r">Intellectual, introspective, and inquisitive. They are cunous, methodical, rational, analytical, and logical [...] scholarly, scientific,
                    technical, or medical [...] avid readers. They like to solve problems, perform experiments, and conduct research.</div>
            </div>
            <div class="prorow">
                <div class="pro_l">Creators (Artistic)</div>
                <div class="pro_r">Creative, intuitive, sensitive, articulate, and expressive. They are unstructured, original, nonconforming, and innovative. They rely on
                    feelings, imagination, and inspiration. They like to work with ideas, abstractions, and concepts. They are spontaneous and open-minded.</div>
            </div>
            <div class="prorow">
                <div class="pro_l">Helpers (Social)</div>
                <div class="pro_r">Kind, generous, cooperative, patient, caring, helpful, empathetic, tactful, and friendly. They excel at socializing, helping others, and
                    teaching. They like tasks that involve teamwork, social interaction,relationship building, and improvement of society.</div>
            </div>
            <div class="prorow">
                <div class="pro_l">Persuader (Enterprising)</div>
                <div class="pro_r">Adventurous, ambitious, assertive, extroverted, energetic, enthusiastic, confident, and optimistic. They are dominant, persuasive, and
                    motivational [...] They like influencing others, being in charge, taking risks, debating, and competing.</div>
            </div>
            <div class="prorow">
                <div class="pro_l" style="border-bottom-left-radius: 8px">Organizers (Conventional)</div>
                <div class="pro_r">Conscientious and conservative. They are logical, efficient, orderiy, and organized. They are thorough and detail-oriented. They value
                    preasion and accuracy. They are reliable. They enjoy practical tasks, quantitative measurements, and structured environments. They
                    follow the rules.</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { GChart } from  "vue-google-charts"
    export default {
        props:['holland'],
        name: "hollandChart",
        components:{
            GChart
        },
        methods:{
            update(){
                this.chartData[1][1] = this.holland[0];
                this.chartData[2][1] = this.holland[1];
                this.chartData[3][1] = this.holland[2];
                this.chartData[4][1] = this.holland[3];
                this.chartData[5][1] = this.holland[4];
                this.chartData[6][1] = this.holland[5];
            },
        },
        mounted() {
            console.log('去的数据',this.holland)
            this.chartData[1][1] = this.holland[0];
            this.chartData[2][1] = this.holland[1];
            this.chartData[3][1] = this.holland[2];
            this.chartData[4][1] = this.holland[3];
            this.chartData[5][1] = this.holland[4];
            this.chartData[6][1] = this.holland[5];
        },
        data () {
            return {
                chartData: [
                    ['Task','Hours per Day'],
                    ['Realistic',1],
                    ['Investigative',1],
                    ['Artistic',1],
                    ['Social',1],
                    ['Enterprising',1],
                    ['Conventional',1],
                ],
                chartOptions: {
                    pieSliceText:'none',
                    colors:['rgb(244,244,244)','#ff9900','#ffa928','#ffba51','#ffca7a','#ffdba3','#ffebcc'],
                    legend:{'position':'labeled'},
                    width:'340',
                    height:'180'
                }
            }
        }
    }
</script>

<style scoped>
    *{
        padding: 0;
        margin: 0;
    }
    .profileTitle{
        width: 100%;
        padding: 20px 20px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
    }
    .GoogleChart{

    }
    .chartTitle{
        display: flex;
        flex-direction:column;
        justify-content: center;
    }
    .chartTitle h3{
        margin-bottom: 10px;
        font-size: 26px;
    }
    .chartTitle p{
        margin-top: 10px;
    }
    .profiletable{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .prorow{
        display: flex;
    }
    .pro_l{
        flex: 0 0 120px;
        padding-left: 10px;
        min-height: 30px;
        display: flex;
        align-items: center;
        text-align: center;
        background: rgb(213,209,200);
        color: rgb(113,112,132);
        font-size: 14px;
        font-weight: bold;
    }
    .pro_r{
        color: #333;
        flex: 1;
        padding: 10px;
        display: flex;
        font-size: 14px;
        align-items: center;
        border-bottom: 1px solid rgb(213,209,200);
        border-right: 1px solid rgb(213,209,200);
    }
    .ground{
        background: rgb(213,209,200);
        border: none;
        color: rgb(113,112,132);
        font-weight: bold;
    }

</style>